import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetDeleteDegree, GetEducationalDegree } from "./thunk";
import { IEducationalDegreeInitialState, IEducationalDegreePayload } from "../types";

const initialState: IEducationalDegreeInitialState = {
    educationDegreeData: [],
    isLoadingDegree: false,
    filteredDegree: [],
    degreeRestoreData: [],
    isViewRestoreDegree: false,
    selectedDegreeIDs: [],
};

const educationDegreeSlice = createSlice({
    name: "educationalDegree",
    initialState,
    reducers: {
        setEducationalDegree: (
            state,
            action: PayloadAction<{
                data: IEducationalDegreePayload[];
                defaultLanguage: string;
            }>
        ) => {
            const { data, defaultLanguage } = action.payload;

            state.educationDegreeData = data;
            state.filteredDegree = data.reduce(
                (acc, item) => {
                    const translation = item.translations.find(t => t.slug === defaultLanguage);
                    if (translation) {
                        acc.push({
                            id: item.id,
                            name: translation.name ?? "",
                            abbreviation: translation.abbreviation ?? "",
                        });
                    }
                    return acc;
                },
                [] as { id: number; name: string; abbreviation: string }[]
            );
        },

        setIsViewRestoreDegree: state => {
            state.isViewRestoreDegree = !state.isViewRestoreDegree;
        },
        deletedRestoreDegree: (state, action) => {
            state.degreeRestoreData = state.degreeRestoreData.filter(elem => elem.id !== action.payload);
        },

        deleteDegree: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.educationDegreeData = state.educationDegreeData.filter(elem => elem.id !== id);
        },
        updateDegree: (state, action: PayloadAction<{ updatedDegree: IEducationalDegreePayload }>) => {
            const { updatedDegree } = action.payload;
            state.educationDegreeData = state.educationDegreeData.map((elem: IEducationalDegreePayload) => {
                if (elem.id === updatedDegree.id) {
                    return {
                        ...elem,
                        ...updatedDegree,
                    };
                }
                return elem;
            });
        },
        setSelectedDegreeIDs: (state, action) => {
            state.selectedDegreeIDs = action.payload;
        },
        setDegreeRestoreData: (state, action) => {
            state.degreeRestoreData = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetEducationalDegree.pending, state => {
                state.isLoadingDegree = true;
            })
            .addCase(GetEducationalDegree.fulfilled, state => {
                state.isLoadingDegree = false;
            })
            .addCase(GetEducationalDegree.rejected, state => {
                state.isLoadingDegree = false;
            })
            .addCase(GetDeleteDegree.pending, state => {
                state.isLoadingDegree = true;
            })
            .addCase(GetDeleteDegree.fulfilled, state => {
                state.isLoadingDegree = false;
            })
            .addCase(GetDeleteDegree.rejected, state => {
                state.isLoadingDegree = false;
            });
    },
});

export const {
    setEducationalDegree,
    setSelectedDegreeIDs,
    deleteDegree,
    updateDegree,
    setDegreeRestoreData,
    setIsViewRestoreDegree,
    deletedRestoreDegree,
} = educationDegreeSlice.actions;
export default educationDegreeSlice;
